export const highlightWithAsteriskIfError = (
  label: string,
  isError: boolean
): string => `${label}${isError ? "*" : ""}`;
